import { SupplierTripMatrix } from "@/app/SupplierTrips/Components/SupplierTripMatrix";
import { Dialog } from "@/components/catalyst/dialog";
import { DialogProvider } from "@/lib/Components/Dialog/Providers/DialogProvider";
import { useDialogState } from "@/lib/Components/Dialog/Hooks/useDialogState";

export function SupplierTripMatrixDialog({
  supplierId,
}: {
  supplierId: string;
}) {
  const { close, isOpen, depth } = useDialogState();

  return (
    <Dialog
      size="full"
      open={isOpen}
      onClose={() => {
        close();
      }}
      as="div"
    >
      <DialogProvider depth={depth + 1}>
        <SupplierTripMatrix supplierId={supplierId} />
      </DialogProvider>
    </Dialog>
  );
}
